import { types, applySnapshot } from 'mobx-state-tree';

const Reward = types
    .model('Reward', {
        id: types.identifierNumber,
        name: types.optional(types.string, ''),
        image_url: types.optional(types.string, ''),
        redeem_description: types.maybeNull(types.string, ''),
        popup_title: types.optional(types.string, ''),
        quantity: types.optional(types.number, 0),
        acquired: types.maybeNull(types.number),
        used: types.maybeNull(types.number),
        expire_at: types.maybeNull(types.string),
        fan_coins: types.optional(types.number, 0),
        popup_text: types.optional(types.string, ''),
        description: types.maybeNull(types.string),
        type: types.optional(types.string, 'avatar'),
        voucher_type: types.maybeNull(types.string),
        sponsor_link: types.maybeNull(types.string, ''),
        use_unused: types.optional(types.boolean, false),
        order_id: types.maybeNull(types.string),
    })
    .actions((self) => ({
        editReward(edited) {
            applySnapshot(self, { ...self, ...edited });
        },
    }));

export default Reward;
